//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("soUserOrganisationsApi", SoUserOrganisationsApiFactory);

    SoUserOrganisationsApiFactory.$inject = ["apiClientFactory"];
    function SoUserOrganisationsApiFactory(apiClientFactory) {

        const routePrefix = "api/";

        return {
            Search: apiClientFactory.post(routePrefix + "souserorganisations/"),
        };
    }
})();
